import { generateTicks, scanTicks, type Band, type TickInformation } from './core';
import { convertAmericanToImpliedProbability } from '@/core/utils';

const bands: Band[] = [[1, 99, 1]];

const ticks = generateTicks(bands, 0);

function preprocessIP(raw: number): number {
  if (raw > 0 && raw < 1) return Math.round(raw * 100);
  if (raw > 100) return Math.round(convertAmericanToImpliedProbability(raw));
  if (raw < -100) return Math.round(convertAmericanToImpliedProbability(raw));
  if (raw >= -100 && raw <= 0) return 2;
  return Math.round(raw);
}

export function getIPTickInfo(rawValue: number): TickInformation {
  const value = preprocessIP(rawValue);
  return scanTicks(value, ticks);
}
